export function chunk(xs: string, n: number): string[]
export function chunk<T>(xs: T[], n: number): T[][]
export function chunk<T>(xs: T[] | string, n: number): Array<T[] | string> {
  const r = []
  for (let i = 0; i < xs.length; i += n) {
    r.push(xs.slice(i, i + n))
  }
  return r
}

/**
 * There is a findLastIndex function in the Array.prototype,
 * but it is not supported in the old browsers. (iOS < 15.4, Chrome < 97)
 */
export function findLastIndex<T>(xs: T[], predicate: (x: T) => boolean): number {
  for (let i = xs.length - 1; i >= 0; i--) {
    if (predicate(xs[i])) {
      return i
    }
  }
  return -1
}
